import { render } from "./AddComputeOffering.vue?vue&type=template&id=05d54eb6&scoped=true"
import script from "./AddComputeOffering.vue?vue&type=script&lang=js"
export * from "./AddComputeOffering.vue?vue&type=script&lang=js"

import "./AddComputeOffering.vue?vue&type=style&index=0&id=05d54eb6&scoped=true&lang=scss"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d54eb6"]])

export default __exports__